var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.content,"placement":_vm.placement}},[_c('div',{staticClass:"image-container btn-img",on:{"mouseenter":_vm.handleTooltipEnter,"mouseleave":_vm.handleTooltipLeave}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }